package us.laantech.common.dto

import kotlinx.serialization.Serializable
import nl.adaptivity.xmlutil.core.impl.multiplatform.name
import us.laantech.common.util.computeEndingInventory
import us.laantech.common.util.generateUUIDv7

enum class SaasProductType {
    // TODO auto generate licenses or allow ability to map in Admin panel
    NONE,
    POS,
    BACKOFFICE,
    LPA
}

@Serializable
data class InternalProductDTO(
    val uuid: String = generateUUIDv7(),

    val productName: String? = null,

    val productType: InternalProductType? = null,

    val website: String? = null,
    val description: String? = null,

    // metadata
    val imageUrl: String? = null,

    val inventoryLog: List<InventoryDTO> = listOf(),

    val sku: String? = null,
    val serial: String? = null,
    val brand: String? = null,

    // system-config contains multiple objects with common keys and will serialize
    // so this is unique to this class, filter by this to avoid serializing from other objects.
    val _class: String? = this::class.name,

    val enabled: Boolean?= null,

    val saasProductType: SaasProductType? = null,

    val releases: List<String> = listOf()
) {

    val inventory: InventoryDTO get() = inventoryLog.computeEndingInventory()

}


enum class InternalProductType {
    SOFTWARE,
    HARDWARE
}